// @flow

const DEST_INPUT_SET = "destAutocmplete/address/set";

export default {
    DEST_INPUT_SET,
}


// WEBPACK FOOTER //
// ./src/Store/Ducks/DestAutocomplete/types.js